import * as z from 'zod';

/**
 * #### Fannie Mae LAR 81 Report: Lender Loan I.D. Change Record
 *
 * The LAR 81 report is an 80-character fixed length string. Character lengths and positions are noted at the individual fields.
 *
 * From Fannie's docs:
 *
 * Transaction Type 81 (Lender Loan I.D. Change Record) must be used to add, delete, or change the
 * information Fannie Mae is carrying in its records for the servicer's unique identifier for the mortgage loan. The
 * servicer can determine the I.D. that Fannie Mae is carrying in its records by reviewing the trial balance report
 * that Fannie Mae provides. (See Detailed Reporting Trial Balance Report (DRTB) Job Aid, which is available on
 * Fannie Mae’s website.)
 */
export const FannieMaeLar81V1 = z.object({
  version: z.literal('1').describe('version'),
  /**
   * ##### Lender Number
   * Numeric length 9; characters 1 - 9.
   */
  lenderNumber: z.string().describe('string'),
  /**
   * ##### Investor
   * Always `'F'` for Fannie; character 10
   */
  investor: z.literal('F').describe('literal'),
  /**
   * ##### Record Identifier
   * Always `'81'`; characters 11 - 12
   */
  recordIdentifier: z.literal('81').describe('literal'),
  /**
   * ##### Source Code
   * Always `'0'`; character 13
   */
  sourceCode: z.literal('0').describe('literal'),
  /**
   * ##### Fannie Mae Loan Number
   * Numeric length 10; characters 14 - 23
   */
  fannieMaeLoanNumber: z.string().describe('string'),
  /**
   * ##### New Lender Loan ID
   * Alphanumeric length 15; characters 24 - 38
   */
  newLenderLoanId: z.string().describe('string'),
  /**
   * The report ends with 42 blank characters, 39 - 80
   */
});
export type FannieMaeLar81V1 = z.infer<typeof FannieMaeLar81V1>;

export const FannieMaeLar81 = FannieMaeLar81V1;
export type FannieMaeLar81 = z.infer<typeof FannieMaeLar81>;
// Make `FannieMaeLar81` a discriminated union on 'version' when changes happen
// export const FannieMaeLar81V2 = z.object({
//   version: z.literal('2'),
//   foo: z.string(),
// });
// export const FannieMaeLar81 = z.discriminatedUnion('version', [FannieMaeLar81V1, FannieMaeLar81V02012025]);
